var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('aside',{staticClass:"dashboard-navigation"},[_c('base-sidebar')],1),_c('main',{staticClass:"dashboard-content",attrs:{"id":"main","role":"main"}},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }